import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { useEffect } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

// Pages
import HomePage from './pages/HomePage'
import NotFoundPage from '../../shared/pages/NotFoundPage'
import RedirectPage from '../../shared/pages/RedirectPage'

// Components
import Header from '../../shared/components/layout/Header'
import Footer from '../../shared/components/layout/Footer'

// Hooks
import { useTheme } from '../../shared/hooks/useTheme'
import { useDocumentLanguage } from '../../shared/hooks/useDocumentLanguage'

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 3,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
})

function PublicApp() {
  useDocumentLanguage()
  const { resolvedTheme, initializeTheme } = useTheme()

  useEffect(() => {
    initializeTheme()
  }, [initializeTheme])

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <div className="min-h-screen bg-gray-50 transition-colors duration-200 dark:bg-gray-900">
          {/* Main Layout */}
          <Header />

          <main className="flex-1">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/:code" element={<RedirectPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </main>

          <Footer />

          {/* Toast Notifications */}
          <Toaster
            position="bottom-right"
            reverseOrder={false}
            gutter={8}
            containerClassName=""
            containerStyle={{}}
            toastOptions={{
              className: '',
              duration: 4000,
              style: {
                background: resolvedTheme === 'dark' ? '#374151' : '#ffffff',
                color: resolvedTheme === 'dark' ? '#f9fafb' : '#111827',
                border:
                  resolvedTheme === 'dark'
                    ? '1px solid #4b5563'
                    : '1px solid #e5e7eb',
              },
              success: {
                duration: 3000,
                iconTheme: {
                  primary: '#10b981',
                  secondary: '#ffffff',
                },
              },
              error: {
                duration: 5000,
                iconTheme: {
                  primary: '#ef4444',
                  secondary: '#ffffff',
                },
              },
            }}
          />
        </div>
      </Router>
    </QueryClientProvider>
  )
}

export default PublicApp
